import { createI18n } from "vue-i18n";
import en from "@/assets/locales/en.json";
import country_en from "@/assets/locales/countries/countries_en.json";
function detectLocale(): string {
  // const stored = localStorage.getItem('locale');
  // if (stored) return stored;
  // const navigatorLang = window.navigator.language.slice(0, 2);
  // if (['en', 'sv'].includes(navigatorLang)) return navigatorLang;
  return "en";
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: "en",
  messages: { en: { ...en, countries: country_en } },
});

export default i18n;
